/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireLARS {
  position: number;
  question: string;
  answers: string[];
  scores: number[];
}

export const Q_LARS: QuestionnaireLARS[] = [
  {
    // tslint:disable-next-line:max-line-length
    position: 1, question: 'Le è mai capitato di non riuscire a controllare la flatulenza? (Emissione di Aria)',
    answers: [
      'No mai',
      'Si, menondi una volta a settimana',
      'Si, almeno una volta a settimana'
    ],
    scores: [
      0,
      4,
      7
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 2, question: 'Le è mai capitato di avere una perdita involontaria di feci liquide?',
    answers: [
      'No mai',
      'Si, meno di una volta a settimana',
      'Si, più di una volta a settimana'
    ],
    scores: [
      0,
      3,
      3
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 3, question: 'Quante volte va di corpo?',
    answers: [
      'più di 7 volte al giorno (su 24 ore)',
      '4-7 volte al giorno (su 24 ore)',
      '1-3 volte al giorno (su 24 ore)',
      'meno di una volta al giorno (su 24 ore)'
    ],
    scores: [
      4,
      2,
      0,
      5
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 4, question: 'Le è mai capitato di dover andare in corpo dopo un\'ora dall\'ultima scarica di feci?',
    answers: [
      'No, mai',
      'Si, meno di una volta a settimana',
      'Si, almeno una volta a settimana'
    ],
    scores: [
      0,
      9,
      11
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 5, question: 'Le capita mai di aver impellente urgenza di evacuare tanto da costringerla a correre alla toilette?',
    answers: [
      'No mai',
      'Si, meno di una volta a settimana',
      'Si, almeno una volta a settimana'
    ],
    scores: [
      0,
      11,
      16
    ]
  }
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class LARSResults {
  patientSSN: string;
  doctorID: string;
  results: string[];
  finalScore: number;

  constructor(doctorID: string, patientSSN: string, results: string[], finalScore: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.finalScore = finalScore;
  }

}
